import pptxgen from "pptxgenjs";
import Pptx from "pptxgenjs";

type downloadpptxType = {
    enrichedPages: any[], pages: any[], data: any
}
export const downloadpptx = ({enrichedPages, pages, data}: downloadpptxType)  => {
    const dataToPptx = enrichedPages.map((page, index) => ({
      elements: page.pageContent,
      backgroundColor: pages?.find((p) => p.id === page.id)?.backgroundColor,
    }));

    let pptx = new pptxgen();
    const pres = new Pptx();
    //pptx.defineLayout({ name: "A4", width: 1024, height: 768 }); // Set layout to A4 size
    // pptx.defineLayout({ name: "A4", width: 8.27, height: 11.695 });
    //pptx.layout = 'A4'
    dataToPptx.forEach((page) => {
      let slide = pptx.addSlide();
      slide.background = { color: page.backgroundColor };

      page.elements.forEach((element: any) => {
        if (
          element.type === "heading" ||
          element.type === "subheading" ||
          element.type === "body"
        ) {
          slide.addText(element.content, {
            x: element.x / 84, // Convert pixels to inches
            y: element.y / 92,
            w:
              element.width === "auto"
                ? undefined
                : element.type === "heading" || element.type === "subheading"
                ? element.width / 92
                : element.width / 86,
            h: element.height === "auto" ? undefined : element.height / 96,
            fontSize:
              element.type === "heading" ? element.fontSize - 10 : element.type === "subheading"
                ? element.fontSize - 5
                : element.fontSize - 3,
            color: element.color,
            align: element.textAlign,
            //shape: "rect",
            line: { size: element.borderWidth, color: element.borderColor },
            fill: { color: element.backgroundColor },
            bold: element.fontWeight === "bold",
            fontFace: element.fontFamily,
          });
        } else if (element.type === "image") {
          const imageProps = {
            x: element.x / 84, // Convert pixels to inches
            y: element.y / 92,
            w: element.width === "auto" ? undefined : element.width / 87,
            h: element.height === "auto" ? undefined : element.height / 92,
            path: element.imageUrl,
            type: "cover",
          };
          slide.addImage(imageProps);
        } else if (
          element.type === "chart" &&
          element.chartConfig &&
          (element?.chartType === "Horizontal Bar Chart" ||
            element?.chartType === "Column Bar Chart")
        ) {
          const chartData = element.chartConfig.data.datasets.map(
            (dataset: any) => ({
              name: dataset.label,
              labels: element.chartConfig.data.labels,
              values: dataset.data,
              chartColors: dataset.backgroundColor,
            })
          );

          slide.addChart(pptx.ChartType.bar, chartData, {
            x: element.x / 84,
            y: element.y / 96,
            w: element.width / 96,
            h: element.height / 96,
            showTitle: element.chartConfig.options.plugins.title.display,
            title: element.chartConfig.options.plugins.title.text,
            legendFontSize: 11,
            titleFontSize: 14,
            barGapWidthPct:
              element?.chartType === "Horizontal Bar Chart" ? 20 : 50,
            legendPos:
              element.chartConfig.options.plugins.legend.position === "top"
                ? "t"
                : "r",
            showLegend: element.chartConfig.options.plugins.legend.display,
            barDir:
              element?.chartType === "Horizontal Bar Chart" ? "bar" : "col",
            chartColors:
              chartData?.length &&
              chartData[0]?.chartColors.map((color: any) => {
                return color?.slice(1, color.length);
              }),
            valAxisMinVal: 0,
          });
        } else if (
          element.type === "chart" &&
          element.chartConfig &&
          (element?.chartType === "Stacked Column Bar Chart" ||
            element?.chartType === "Stacked Horizontal Bar Chart" ||
            element?.chartType === "Progress Chart")
        ) {
          // Extract chart data
          const chartConfig = element.chartConfig;
          const chartType =
            chartConfig.type === "bar" ? "barStacked" : "columnStacked";
          const datasets = chartConfig.data.datasets;
          const labels = chartConfig.data.labels;

          // Prepare chart data for pptxgen
          const chartData = datasets.map((dataset: any) => ({
            name: dataset.label,
            labels: labels,
            values: dataset.data,
          }));

          // Chart opt ions
          const chartOptions: any = {
            x: element.x / 84, // Convert from pixels to inches
            y: element.y / 96,
            w: element.width / 96,
            h: element.height / 96,
            barDir:
              element?.chartType === "Stacked Horizontal Bar Chart" ||
              element?.chartType === "Progress Chart"
                ? "bar"
                : "col",
            bar3DShape: "box",
            barGapWidthPct: 50,
            showTitle: element.chartConfig.options.plugins.title.display,
            legendFontSize: 11,
            titleFontSize: 14,
            chartColors: element.chartConfig.data.datasets.map(
              (dataset: any) => dataset.backgroundColor
            ),
            showLegend: chartConfig.options.plugins.legend.display,
            legendPos:
              chartConfig.options.plugins.legend.position === "top" ? "t" : "r",
            showValue: false,
            barGrouping: "stacked", // Enable stacking
            title: chartConfig.options.plugins.title.display
              ? chartConfig.options.plugins.title.text
              : "",
          };

          // Add stacked chart to slide
          slide.addChart(pptx.ChartType.bar, chartData, chartOptions);
        } else if (
          element.type === "chart" &&
          element.chartConfig &&
          (element?.chartType === "Pie Chart" ||
            element?.chartType === "Donut Chart")
        ) {
          const chartData = element.chartConfig.data.datasets.map(
            (dataset: any) => ({
              name: dataset.label,
              labels: element.chartConfig.data.labels,
              values: dataset.data,
              chartColors: dataset.backgroundColor,
            })
          );

          const chartType =
            element?.chartType === "Donut Chart"
              ? pptx.ChartType.doughnut
              : pptx.ChartType.pie;
          slide.addChart(chartType, chartData, {
            x: element.x / 86,
            y: element.y / 96,
            legendPos: "t",
            showLegend: element.chartConfig.options.plugins.legend.display,
            holeSize: element?.chartType === "Donut Chart" ? 60 : 0,
            showTitle: element.chartConfig.options.plugins.title.display,
            title: element.chartConfig.options.plugins.title.text,
            legendFontSize: 11,
            titleFontSize: 14,
            w: element.width / 80,
            h: element.height / 80,
            chartColors:
              chartData?.length &&
              chartData[0]?.chartColors.map((color: any) => {
                return color?.slice(1, color.length);
              }),
          });
          // add center text to doughnut chart
          if (element?.chartType === "Donut Chart") {
            slide.addText(element?.content, {
              x: element.x / 86,
              y: element.y / 96,
              w: element.width / 80,
              h: element.height / 80,
              fontSize: 14,
              align: "center",
            });
          }
        } else if (element.type === "shape") {
          console.log(element, "from ppt");
          console.log(element.shape);

          slide.addShape(
            pres.ShapeType[element.shape.type as keyof typeof pres.ShapeType],
            {fill: { color: element.color  },  x: element.x / 84, // Convert from pixels to inches
            y: element.y / 96,
            w: element.width / 96,
            h: element.height / 96,  }
          );
        }
      });
    });

    pptx.writeFile({ fileName: `${data?.name}.pptx` });
  };